import { render, staticRenderFns } from "./EfsCapCertificateModal.vue?vue&type=template&id=5bea1cb6&"
import script from "./EfsCapCertificateModal.vue?vue&type=script&lang=js&"
export * from "./EfsCapCertificateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports